// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__v9lwf","title":"Images45_title__Fs93U","images":"Images45_images__3TIu4"};